import React from 'react';
import { Link } from 'react-router-dom';

import { css } from '@emotion/react';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import { useQueryClient } from 'react-query';
import { useSetRecoilState } from 'recoil';

import Layer from '@components/Common/Layer';

import {
  accessTokenStorage,
  expirationDateStorage,
} from '@storage/authStorage';

import { useInternalRouter } from '@hooks/useInternalRouter';

import { palette } from '@styles/theme';

import { auth } from '@constants/state';

interface Props {
  open: boolean;
  handleOpen: () => void;
}

/** 메인 컴포넌트 */
const UserLayer = ({ open, handleOpen }: Props) => {
  const router = useInternalRouter();
  const setAuth = useSetRecoilState(auth);
  const queryClient = useQueryClient();

  const handleLogOut = () => {
    accessTokenStorage.clear();
    expirationDateStorage.clear();
    setAuth({
      isLogin: false,
      name: '',
      email: '',
      role: undefined,
      company: '',
      companyId: undefined,
    });
    queryClient.clear();
    router.replace('/');
  };

  return (
    <>
      {open && (
        <Layer
          open={open}
          handleOpen={handleOpen}
          width={210}
          position={{ top: '190px' }}
        >
          <div css={container}>
            <div css={wrapper}>
              <Link to="/mypage" onClick={handleOpen}>
                <div css={setting}>
                  <SettingsOutlinedIcon />
                  사용자 설정
                </div>
              </Link>
              <div css={[setting, logout]} onClick={handleLogOut}>
                <LogoutOutlinedIcon />
                로그아웃
              </div>
            </div>
          </div>
        </Layer>
      )}
    </>
  );
};

export default UserLayer;

const container = css`
  display: flex;
  padding: 10px;
  width: 100%;
`;

const wrapper = css`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const setting = css`
  display: flex;
  width: 100%;
  align-items: center;
  gap: 5px;
  font-size: 14px;
  cursor: pointer;
  padding: 5px;
  border-radius: 5px;

  &:hover {
    background-color: ${palette.gray2};
  }
`;

const logout = css`
  svg {
    path {
      fill: ${palette.primaryColor};
    }
  }
  color: ${palette.primaryColor};

  &:hover {
    background-color: #d428801e;
  }
`;
